
import Vue, { PropType } from "vue";
import DcmPropertiesForm from "../components/DcmPropertiesForm.vue";
import { DcmMetadataActions } from "../interfaces/DcmListActions";
import { DcmMetadataForm, ObjectTypeId } from "../interfaces/DcmMetadataConfig";
import { MetadataField } from "@/@modules/dcm/services/properties";

export default Vue.extend({
  components: { DcmPropertiesForm },
  props: {
    item: {
      type: Object,
      required: true,
    },
    metadataActions: {
      type: Object as PropType<DcmMetadataActions>,
      required: true,
    },
  },
  data() {
    return {
      isReadyToStartComparison: false,
      isUpdateMode: false,
      initialForm: {} as DcmMetadataForm,
      fields: undefined as MetadataField[] | undefined,
      form: {} as DcmMetadataForm,
      valid: false,
    };
  },
  created() {
    this.fields = this.metadataActions.preview.metadataFields[
      this.item[this.metadataActions.preview.itemTypeKey] as ObjectTypeId
    ];
  },
  computed: {
    isEditAuthorized(): boolean {
      if (!this.isReadyToStartComparison) {
        return false;
      } else {
        for (const key of Object.keys(this.form)) {
          if (
            this.initialForm[key] !== this.form[key] &&
            (this.initialForm[key] === undefined ? !!this.form[key] : true)
          ) {
            return true && this.valid;
          }
        }
        return false;
      }
    },
    isUpdateBtnShown(): boolean {
      return (
        !this.isUpdateMode &&
        !!this.metadataActions?.update &&
        (this.metadataActions.update.isShown ? this.metadataActions.update.isShown(this.item) : true)
      );
    },
    title(): string {
      return this.$tc(
        this.isUpdateMode
          ? this.metadataActions?.update?.label ?? "dcm.updateMetadata"
          : this.metadataActions?.preview.label ?? "dcm.previewMetadata"
      );
    },
  },
  methods: {
    cleanFormBeforeEdit() {
      if (this.fields) {
        for (const { metadataName, isReadOnly } of this.fields) {
          if (isReadOnly) {
            delete this.form[metadataName];
          }
        }
        if (this.metadataActions.update?.setMetadata) {
          this.metadataActions.update?.setMetadata(this.form);
        }
        this.$modal.close(this.form);
      }
    },
    handleError() {
      this.$modal.close(false);
      this.$snackbar.show("Cannot open metadata: missing fields", 10000, [{ label: "close", value: "" }], {
        error: true,
      });
    },
    setComparisonData(data: DcmMetadataForm) {
      this.initialForm = data;
      this.isReadyToStartComparison = true;
    },
    async switchToUpdateMode() {
      this.fields = this.metadataActions.update!.metadataFields[
        this.item[this.metadataActions.update!.itemTypeKey] as ObjectTypeId
      ];
      (this.$refs.dcmPropertiesForm as any).bindFields(true);
    },
  },
});
